// aiThreadUtils.js — Ai feed thread helpers (client)

import { MESSAGE_TYPES } from 'spaces/constants/aiConstants';

/** AI-authored roots that should render with Ai chrome in the thread panel. */
export function isAiThreadRootMessage(message) {
  const messageType = String(message?.messageType || '').trim();
  return messageType === MESSAGE_TYPES.AI_FEED_ITEM
    || messageType === MESSAGE_TYPES.AI_SURFACE
    || messageType === MESSAGE_TYPES.AI_TEXT;
}

/** Any top-level message in a threadable Ai (or TEXT) channel may start a thread. */
export function canReplyInThreadOnMessage(message, channelSupportsThreads) {
  if (!channelSupportsThreads || !message?.key) return false;
  if (message?.parentMessageKey || message?.threadRootKey) return false;
  return true;
}
